// Technicians mock data \u2014 extended profiles with performance, certifications, schedule, payroll
export const techProfiles = [
  {
    id: "t1",
    name: "Marcus Johnson",
    role: "Senior HVAC Tech",
    avatar: "MJ",
    color: "#2563EB",
    status: "On Job",
    phone: "(602) 555-3340",
    email: "marcus.j@servicepro.com",
    hireDate: "2018-04-12",
    vehicle: "Van #14 \u2014 Ford Transit (ABC-2240)",
    location: { lat: 33.4484, lng: -112.0740, lastPing: "2025-07-08T09:42" },
    certifications: [
      { id: "epa608", name: "EPA Section 608 Universal", expires: "2027-09-22", status: "Active" },
      { id: "naties", name: "NATE \u2014 Air Conditioning", expires: "2026-04-18", status: "Active" },
      { id: "azhvac", name: "AZ HVAC License #C-39", expires: "2025-12-31", status: "Active" },
    ],
    performance: {
      jobsToday: 3, jobsWeek: 18, jobsMonth: 76,
      revenueToday: 3820, revenueWeek: 21420, revenueMonth: 92400,
      avgTicket: 1216, conversionRate: 72.4, rating: 4.9, reviewCount: 142,
    },
    schedule: {
      Mon: { active: true, start: "07:00", end: "17:00" },
      Tue: { active: true, start: "07:00", end: "17:00" },
      Wed: { active: true, start: "07:00", end: "17:00" },
      Thu: { active: true, start: "07:00", end: "17:00" },
      Fri: { active: true, start: "07:00", end: "15:00" },
      Sat: { active: true, start: "08:00", end: "13:00" },
      Sun: { active: false, start: "", end: "" },
    },
    daysOff: ["2025-07-15", "2025-07-16", "2025-08-04"],
    payroll: { hourlyRate: 38.50, commissionPct: 8, hoursThisPeriod: 72.5, periodEarnings: 4570.25 },
    weekJobs: [
      { id: "J-10428", date: "2025-07-08", customer: "Jennifer Williams", type: "HVAC Repair", status: "In Progress" },
      { id: "J-10440", date: "2025-07-08", customer: "Marriott Phoenix", type: "HVAC Install", status: "Scheduled" },
      { id: "J-10434", date: "2025-07-08", customer: "Jennifer Williams", type: "HVAC Tune-up", status: "Scheduled" },
      { id: "J-10448", date: "2025-07-09", customer: "Westside Diner", type: "HVAC Service", status: "Scheduled" },
    ],
  },
  {
    id: "t2",
    name: "Sara Chen",
    role: "Plumbing Specialist",
    avatar: "SC",
    color: "#10B981",
    status: "En Route",
    phone: "(602) 555-3341",
    email: "sara.c@servicepro.com",
    hireDate: "2020-08-20",
    vehicle: "Van #08 \u2014 Ford Transit (XYZ-1124)",
    location: { lat: 33.4520, lng: -112.0780, lastPing: "2025-07-08T09:41" },
    certifications: [
      { id: "azplmb", name: "AZ Plumbing License", expires: "2026-06-15", status: "Active" },
      { id: "backflow", name: "Backflow Prevention", expires: "2025-08-22", status: "Expiring Soon" },
    ],
    performance: {
      jobsToday: 2, jobsWeek: 14, jobsMonth: 58,
      revenueToday: 2410, revenueWeek: 14820, revenueMonth: 64280,
      avgTicket: 980, conversionRate: 68.0, rating: 4.8, reviewCount: 96,
    },
    schedule: {
      Mon: { active: true, start: "07:30", end: "16:30" },
      Tue: { active: true, start: "07:30", end: "16:30" },
      Wed: { active: true, start: "07:30", end: "16:30" },
      Thu: { active: true, start: "07:30", end: "16:30" },
      Fri: { active: true, start: "07:30", end: "16:30" },
      Sat: { active: false, start: "", end: "" },
      Sun: { active: false, start: "", end: "" },
    },
    daysOff: ["2025-07-22", "2025-07-23"],
    payroll: { hourlyRate: 34.00, commissionPct: 7, hoursThisPeriod: 70.0, periodEarnings: 3656.40 },
    weekJobs: [
      { id: "J-10429", date: "2025-07-08", customer: "Coronado Plaza HOA", type: "Plumbing Service", status: "Scheduled" },
      { id: "J-10441", date: "2025-07-08", customer: "Sandra Park", type: "Water Heater", status: "Scheduled" },
    ],
  },
  {
    id: "t3",
    name: "Diego Ramirez",
    role: "Electrical Lead",
    avatar: "DR",
    color: "#F59E0B",
    status: "Available",
    phone: "(602) 555-3342",
    email: "diego.r@servicepro.com",
    hireDate: "2017-11-04",
    vehicle: "Van #04 \u2014 Mercedes Sprinter (LMN-7755)",
    location: { lat: 33.4440, lng: -112.0680, lastPing: "2025-07-08T09:40" },
    certifications: [
      { id: "azelec", name: "AZ Electrical Master License", expires: "2027-02-28", status: "Active" },
      { id: "osha30", name: "OSHA-30 Construction", expires: "2026-05-10", status: "Active" },
    ],
    performance: {
      jobsToday: 1, jobsWeek: 12, jobsMonth: 48,
      revenueToday: 320, revenueWeek: 11240, revenueMonth: 52800,
      avgTicket: 1100, conversionRate: 65.5, rating: 4.7, reviewCount: 84,
    },
    schedule: {
      Mon: { active: true, start: "06:30", end: "15:30" },
      Tue: { active: true, start: "06:30", end: "15:30" },
      Wed: { active: true, start: "06:30", end: "15:30" },
      Thu: { active: true, start: "06:30", end: "15:30" },
      Fri: { active: true, start: "06:30", end: "15:30" },
      Sat: { active: false, start: "", end: "" },
      Sun: { active: false, start: "", end: "" },
    },
    daysOff: ["2025-07-04", "2025-12-22", "2025-12-23"],
    payroll: { hourlyRate: 42.00, commissionPct: 9, hoursThisPeriod: 70.0, periodEarnings: 4452.80 },
    weekJobs: [
      { id: "J-10430", date: "2025-07-08", customer: "Robert Hayes", type: "Electrical Inspection", status: "Completed" },
      { id: "J-10442", date: "2025-07-08", customer: "Phoenix Convention Ctr", type: "Panel Upgrade", status: "Scheduled" },
    ],
  },
  {
    id: "t4",
    name: "Aisha Patel",
    role: "HVAC Tech",
    avatar: "AP",
    color: "#8B5CF6",
    status: "On Job",
    phone: "(602) 555-3343",
    email: "aisha.p@servicepro.com",
    hireDate: "2019-06-15",
    vehicle: "Van #11 \u2014 Ford Transit (DEF-9988)",
    location: { lat: 33.4560, lng: -112.0820, lastPing: "2025-07-08T09:43" },
    certifications: [
      { id: "epa608", name: "EPA Section 608 Universal", expires: "2026-08-10", status: "Active" },
      { id: "naties", name: "NATE \u2014 Heat Pump", expires: "2027-03-15", status: "Active" },
    ],
    performance: {
      jobsToday: 4, jobsWeek: 22, jobsMonth: 88,
      revenueToday: 4220, revenueWeek: 26840, revenueMonth: 108400,
      avgTicket: 1232, conversionRate: 74.8, rating: 4.9, reviewCount: 168,
    },
    schedule: {
      Mon: { active: true, start: "07:00", end: "17:00" },
      Tue: { active: true, start: "07:00", end: "17:00" },
      Wed: { active: true, start: "07:00", end: "17:00" },
      Thu: { active: true, start: "07:00", end: "17:00" },
      Fri: { active: true, start: "07:00", end: "17:00" },
      Sat: { active: true, start: "09:00", end: "14:00" },
      Sun: { active: false, start: "", end: "" },
    },
    daysOff: ["2025-08-12", "2025-08-13", "2025-08-14"],
    payroll: { hourlyRate: 36.00, commissionPct: 7.5, hoursThisPeriod: 78.0, periodEarnings: 4836.00 },
    weekJobs: [
      { id: "J-10431", date: "2025-07-08", customer: "Desert Sun Apartments", type: "HVAC Install", status: "Dispatched" },
    ],
  },
  {
    id: "t5",
    name: "Tom O'Brien",
    role: "Plumber",
    avatar: "TO",
    color: "#EF4444",
    status: "Lunch",
    phone: "(602) 555-3344",
    email: "tom.o@servicepro.com",
    hireDate: "2021-02-08",
    vehicle: "Van #16 \u2014 Ram ProMaster (GHI-4422)",
    location: { lat: 33.4500, lng: -112.0650, lastPing: "2025-07-08T09:35" },
    certifications: [
      { id: "azplmb", name: "AZ Plumbing License", expires: "2025-09-30", status: "Expiring Soon" },
      { id: "gasfit", name: "Gas Piping Installer", expires: "2027-01-12", status: "Active" },
    ],
    performance: {
      jobsToday: 2, jobsWeek: 11, jobsMonth: 42,
      revenueToday: 2050, revenueWeek: 8420, revenueMonth: 36400,
      avgTicket: 866, conversionRate: 60.2, rating: 4.6, reviewCount: 58,
    },
    schedule: {
      Mon: { active: true, start: "08:00", end: "17:00" },
      Tue: { active: true, start: "08:00", end: "17:00" },
      Wed: { active: false, start: "", end: "" },
      Thu: { active: true, start: "08:00", end: "17:00" },
      Fri: { active: true, start: "08:00", end: "17:00" },
      Sat: { active: true, start: "08:00", end: "13:00" },
      Sun: { active: false, start: "", end: "" },
    },
    daysOff: ["2025-07-30", "2025-07-31"],
    payroll: { hourlyRate: 32.00, commissionPct: 6, hoursThisPeriod: 64.0, periodEarnings: 2552.40 },
    weekJobs: [
      { id: "J-10432", date: "2025-07-08", customer: "Emily Carter", type: "Drain Cleaning", status: "Scheduled" },
      { id: "J-10443", date: "2025-07-08", customer: "Westside Diner", type: "Gas Service", status: "Scheduled" },
    ],
  },
  {
    id: "t6",
    name: "Priya Kapoor",
    role: "Electrician",
    avatar: "PK",
    color: "#06B6D4",
    status: "Available",
    phone: "(602) 555-3345",
    email: "priya.k@servicepro.com",
    hireDate: "2022-09-12",
    vehicle: "Van #19 \u2014 Ford Transit (JKL-3311)",
    location: { lat: 33.4470, lng: -112.0710, lastPing: "2025-07-08T09:38" },
    certifications: [
      { id: "azelec", name: "AZ Electrical Journeyman", expires: "2026-11-04", status: "Active" },
      { id: "osha10", name: "OSHA-10 General Industry", expires: "2026-03-22", status: "Active" },
    ],
    performance: {
      jobsToday: 1, jobsWeek: 9, jobsMonth: 38,
      revenueToday: 1320, revenueWeek: 8240, revenueMonth: 32800,
      avgTicket: 862, conversionRate: 62.0, rating: 4.8, reviewCount: 46,
    },
    schedule: {
      Mon: { active: true, start: "07:00", end: "16:00" },
      Tue: { active: true, start: "07:00", end: "16:00" },
      Wed: { active: true, start: "07:00", end: "16:00" },
      Thu: { active: true, start: "07:00", end: "16:00" },
      Fri: { active: true, start: "07:00", end: "16:00" },
      Sat: { active: false, start: "", end: "" },
      Sun: { active: false, start: "", end: "" },
    },
    daysOff: [],
    payroll: { hourlyRate: 30.00, commissionPct: 6, hoursThisPeriod: 68.0, periodEarnings: 2534.40 },
    weekJobs: [
      { id: "J-10433", date: "2025-07-08", customer: "James Liu", type: "Panel Upgrade", status: "Scheduled" },
    ],
  },
];

export const statusColorMap = {
  "On Job": { bg: "#DCFCE7", text: "#166534", dot: "#10B981" },
  "En Route": { bg: "#FEF3C7", text: "#92400E", dot: "#F59E0B" },
  "Available": { bg: "#DBEAFE", text: "#1E40AF", dot: "#3B82F6" },
  "Lunch": { bg: "#FEE2E2", text: "#991B1B", dot: "#EF4444" },
  "Off": { bg: "#F1F5F9", text: "#475569", dot: "#94A3B8" },
};

export const certStatusColors = {
  "Active": { bg: "#DCFCE7", text: "#166534" },
  "Expiring Soon": { bg: "#FEF3C7", text: "#92400E" },
  "Expired": { bg: "#FEE2E2", text: "#991B1B" },
};

export const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
